/*
 * Copyright (c) Siemens Energy AG 2020 ALL RIGHTS RESERVED
 * I&C Monitors and Advisors (ICMA)
 */
import React from 'react';
import NavigationBarComponent from './NavigationBarComponent';
import ContentComponent from './ContentComponent';
import axios from 'axios';
import { MENU_SHORT_DESCRIPTION } from '../../../store/configPageDescriptionConfig';

// import "../css/bootstrap-iso.css";

export default class ConfigurationPageComponent extends React.Component {
  constructor(props) {
    super(props);

    // bind all handlers
    this.handleUsecaseSelect = this.handleUsecaseSelect.bind(this);

    // set state
    this.state = {
      services: this.props.configServices,
      selection: null,
      access: true,
      selectedUseCase: '',
      deployment: process.env.SERVICE_KEY || 'master',
      configResource: 'pi',
      piCustomDomainPath: 'pi',
      menuDesc: null,
      lpMapping: this.props.lpMapping
    };
  }

  componentDidMount() {
    this.props.setCurrentRouteState('cp', 'Configuration Page');
    let ppidNameMapping =
      this.state.lpMapping?.data?.['globalSettings']?.['ppidToPnameMapping'];
    if (
      ppidNameMapping !== undefined &&
      ppidNameMapping[this.props.settings.ppid] === undefined
    ) {
      console.log("User don't have access");
      this.setState({ access: false });
    }
  }
  componentWillReceiveProps(nextProps) {
    this.setState({ ...nextProps }, () => {
      this.setState({
        services: this.props.configServices,
        selection: null,
        access: true,
        selectedUseCase: '',
        deployment: process.env.SERVICE_KEY || 'master',
        configResource: 'pi',
        piCustomDomainPath: 'pi',
        menuDesc: null,
        lpMapping: this.props.lpMapping
      });
    });
  }
  /**
   * Returns email from token
   * @param token
   * @returns {string<email>}
   */
  getEmailFromToken(token) {
    let email = '';
    if (token) {
      let base64Url = token.split('.')[1];
      if (base64Url) {
        let base64 = base64Url.replace('-', '+').replace('_', '/');
        let parsedSecurityToken = JSON.parse(window.atob(base64));
        if (parsedSecurityToken && parsedSecurityToken.sub) {
          email = parsedSecurityToken['http://cep.com/email'];
        }
      }
    }
    return email;
  }
  /**
   * Returns all servicestructures based on the deployment (e.g. "branch_cs" for branches or just "cs" for all service structures of all services)
   * @param token
   * @param settings
   * @returns {Promise<any>}
   */
  getServiceStructures() {
    let { token, server, ppid } = this.props.settings;
    // for local development
    // configResource = 'pi';
    const url = `${server}${this.state.piCustomDomainPath}/${this.state.configResource}.config/pi.servicestructures/${ppid}/${this.state.deployment}`;
    return axios({
      method: 'get',
      url: url,
      headers: { Authorization: `Bearer ${token}` }
    });
  }

  /**
   * Handler for selected usecase in the navigation menu
   * @param selection
   */
  handleUsecaseSelect(serviceId, usecaseId) {
    let menuDesc = MENU_SHORT_DESCRIPTION.find(
      (m) => m.url === `${serviceId}${usecaseId}`
    );
    this.setState({
      selection: { serviceId: serviceId, usecaseId: usecaseId },
      selectedUseCase: serviceId + usecaseId,
      menuDesc: menuDesc ? menuDesc.description : null
    });
  }

  render() {
    if (this.state.access && Object.keys(this.state.services).length !== 0) {
      return (
        <div className="dls-cs-wrapper" lang="en">
          <NavigationBarComponent
            onUsecaseSelect={this.handleUsecaseSelect}
            selectedUseCase={this.state.selectedUseCase}
            services={this.state.services}
          />

          <ContentComponent
            settings={this.props.settings}
            selection={this.state.selection}
            menuDesc={this.state.menuDesc}
            ppid={this.props.ppid}
            {...this.state}
          />

          <div className="dls-cs-cleared"></div>
        </div>
      );
    } else {
      return (
        <div className="dls-cs-error" lang="en">
          <h3>You don't have access to this page</h3>
        </div>
      );
    }
  }
}
